module.exports = __webpack_public_path__ + "img/20190603162355931.a985c90b.png";